<template>
  <div v-if="ready" class="container">
    <h1 style="display: none">Portfolio</h1>

    <div class="portfolio">
      <div v-masonry gutter="12" item-selector=".item" transition-duration="0.4s">
        <div v-for="(item, index) in loadedPictures" :key="'picture'+index" v-masonry-tile class="item">
          <img :alt="`Photo ©David Cannon`" :src="getImgSrc(item)" class="homepage-photo"/>
        </div>
      </div>
    </div>
    <infinite-loading
        :distance="distance"
        force-use-infinite-wrapper="window"
        spinner="spiral"
        @infinite="loadMorePictures">
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>

  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";

export default {
  name: "Home.vue",
  metaInfo: {
    title: 'DAVID CANNON',
    titleTemplate: null
  },
  data() {
    return {
      page: 0,
      loadedPictures: [],
      photos: [],
      ready: false,
      loading: false,
      distance: 50,
      loadLimit: 12,
      gridOptions: {
        width: 320,
        padding: {
          default: 12,
          1: 6,
          2: 8
        }
      }
    };
  },
  components: {InfiniteLoading},

  mounted() {
    this.loadLimit = this.isMobile() ? 4 : 12;
    this.photos = require.context("@/assets/home-photos/optimized/desktop", false, /^.*\.jpg|.*\.gif|.*\.png$/);
    this.ready = true;
    window.addEventListener('resize', this.onResize);
  },

  methods: {
    async addPhotos() {
      let start = this.page;
      for (let i = start, len = Math.min((start + this.loadLimit), this.photos.keys().length); i < len; i++) {
        await this.loadedPictures.push(this.photos.keys()[i]);
        this.page++;
      }
    },
    getImgSrc(img) {
      return require("@/assets/home-photos/optimized/desktop" + img.slice(1));
    },
    loadMorePictures($state) {
      setTimeout(async () => {
        if (!this.loading) {

          //Prevent dispatch to be made if a call is already being executed
          this.loading = true;
          this.distance = -Infinity;

          await this.addPhotos();

          if (this.photos.keys().length > 1) {
            if (this.loadedPictures.length < this.photos.keys().length) {
              $state.loaded();
            } else {
              $state.complete();
            }

          } else {
            $state.complete();
          }

          this.loading = false;
          this.distance = 50;
        }
      }, 250);
    },
    validatePicturesLimit() {
      const oldLimit = this.loadLimit;
      this.loadLimit = this.isMobile() ? 4 : 12;
      if (oldLimit !== this.loadLimit && oldLimit < this.loadLimit) {
        this.addPhotos();
      }
    },
    isMobile() {
      return window.matchMedia("(max-width: 560px)").matches;
    },
    onResize() {
      this.validatePicturesLimit();
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }
};
</script>

<style lang="scss" scoped>

.portfolio {
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
}

/* PORTFOLIO GRID */
.item {
  width: calc(25% - 9px);
  margin-bottom: 1rem;

  @media screen and (max-width: 1024px) {
    width: calc(33.33% - 8px);
  }

  @media screen and (max-width: 768px) {
    width: calc(50% - 6px);
  }

  @media screen and (max-width: 480px) {
    width: 100%;
  }

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
